<main>
  <div>

    <label for="oldPwd">Mot de passe: </label>
    <mat-form-field appearance="fill">
      <input matInput id="oldPwd" type="password" [formControl]="currentPasswordControl">
    </mat-form-field>
    <label *ngIf="currentPasswordControl.invalid && currentPasswordControl.touched">Mot de passe nécessaire</label>
    <label *ngIf="currentPasswordControl.errors?.incorrectPassword">Mot de passe incorrect</label>
  </div>
    <div>
      <label for="newPwd">Nouveau mot de passe: </label>
      <mat-form-field appearance="fill">
        <input matInput id="newPwd" type="password" [(ngModel)]="newPassword" [formControl]="newPasswordControl">
      </mat-form-field>
      <label *ngIf="newPasswordControl.invalid && newPasswordControl.touched">Mot de passe nécessaire</label>
    </div>
    <div>
      <label for="confirmPwd">Confirmation du mot de passe </label>
      <mat-form-field appearance="fill">
        <input matInput id="confirmPwd" type="password" [(ngModel)]="confirmNewPassword" [formControl]="confirmNewPasswordControl">
      </mat-form-field>
      <label *ngIf="newPasswordControl.touched && newPasswordControl.errors?.notEqual">Le mot de passe n'est pas identique</label>
    </div>

    <div>
      <button mat-raised-primary (click)="update()">Confirmation mot de passe</button>
    </div>
</main>
